import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Button, Grid } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import DeleteIcon from "@mui/icons-material/Delete";

const UploadComp = (props) => {
  const { file, handleImageChange, name, sx, label, buttonText, textSize, xs, handleDelete } = props;
  const [filePreview, setFilePreview] = useState(null);
  const [fileName, setFileName] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (file instanceof Blob) {
      if (file.type === "application/pdf") {
        setFileName(file.name);
        setFilePreview(null);
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFilePreview(reader.result);
        };
        reader.readAsDataURL(file);
        setFileName(null);
      }
    } else {
      setFilePreview(null);
      setFileName(null);
    }
  }, [file]);

  const text = buttonText ? buttonText : "Upload";
  const buttonSx = sx
    ? sx
    : {
        backgroundColor: "black",
        width: "12rem",
        color: "white",
        border: "1px dashed grey",
        height: "2.5rem",
        textTransform: "none",
        "&:hover": {
          backgroundColor: `black`,
        },
      };

  return (
    <Grid
      sx={{
        minHeight: "100px",
        maxHeight: "200px",
        display: "flex",
        flexDirection: "column",
      }}
      item
      xs={xs ? xs : 4}
    >
      <Typography
        sx={{
          color: "rgba(255, 255, 255, .5)",
          fontSize: "13px",
          height: "10px",
          marginBottom: "12px",
        }}
        variant="subtitle2"
      >
        {label}
        {!props.docSubmit ? (
          <Box
            sx={{
              color: "red",
              marginRight: "20px",
            }}
            component="span"
          >
            *
          </Box>
        ) : null}
      </Typography>
      <input
        type="file"
        ref={fileInputRef}
        id={name}
        accept=".pdf, image/*"
        style={{ display: "none" }}
        name={name}
        onChange={handleImageChange}
      />
      <label htmlFor={name}>
        <Button sx={buttonSx} variant="contained" component="span">
          <UploadIcon style={{ fontSize: "17px" }} />
          &nbsp;
          <span style={{ fontSize: textSize ? textSize : "10px", color: "white" }}>
            {`${text}`}
          </span>
        </Button>
      </label>

      {filePreview ? (
        <div className="d-flex align-items-center">
          <img
            src={filePreview}
            alt="Image Preview"
            style={{ width: "50px", height: "50px", margin: "10px" }}
          />
          <DeleteIcon
            sx={{ cursor: "pointer" }}
            onClick={() => { props?.docSubmit ? handleDelete(fileInputRef, props?.index) : handleDelete(name, fileInputRef) }}
            className="text-danger"
          />
        </div>
      ) : fileName ? (
        <div className="d-flex align-items-center">
          <a href={URL.createObjectURL(file)} download={fileName} style={{ margin: "10px", color: "blue", textDecoration: "underline" }}>
            {fileName}
          </a>
          <DeleteIcon
            sx={{ cursor: "pointer" }}
            onClick={() => { props?.docSubmit ? handleDelete(fileInputRef, props?.index) : handleDelete(name, fileInputRef) }}
            className="text-danger"
          />
        </div>
      ) : null}
    </Grid>
  );
};

export default UploadComp;
